import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Drawer,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Box,
    CssBaseline,
    Tooltip,
    LinearProgress,
    useMediaQuery,
    Paper,
    Menu,
    MenuItem,
    Button,
    Modal,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import HomeIcon from "@mui/icons-material/Home";
import { Outlet, NavLink, useNavigation, Link } from "react-router-dom";
import {
    Article,
    Business,
    CurrencyRubleOutlined,
    HistoryEdu,
    HowToVote,
    Newspaper,
    SmartToyOutlined,
} from "@mui/icons-material";
import HelpIcon from "@mui/icons-material/Help";

import emoji from "./images/emoji.svg";
import share from "./images/share.svg";
import message from "./images/message.svg";
import home from "./images/home.svg";
import activeHome from "./images/activeHome.svg";
import more from "./images/more.svg";
import avatar from "./images/avatar.png";
import logo from "./images/ikm-logo.svg";

import style from "./Layout.module.scss";
import { useAuthStore } from "../../store/auth.store";
import { PepAgreementModal } from "../PepAgreement/PepAgreementModal";
import { useRef, useState } from "react";
import { useMetersStore } from "../../store/meters.store";

const APPBAR = 64; // высота шапки
const W = 240; // ширина меню (полная)
const MINI = 72; // ширина меню (минимальная)

// массив с путями страниц и их икнками
const items = [
    { to: "/admin/index", label: "Главная", Icon: HomeIcon },
    { to: "/admin/transactions", label: "История платежей", Icon: HistoryEdu },
    {
        to: "/admin/payments",
        label: "История по счёту",
        Icon: CurrencyRubleOutlined,
    },
    { to: "/admin/meters", label: "Счетчики", Icon: SmartToyOutlined },
    { to: "/admin/news", label: "Новости", Icon: Newspaper },
    { to: "/admin/organizations", label: "Организации", Icon: Business },
    { to: "/admin/meetings", label: "Собрания", Icon: HowToVote },
    { to: "/admin/tickets", label: "Обращения", Icon: Article },
];

export default function Layout() {
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
    const [openDesktop, setOpenDesktop] = useState(true);
    const [openMobile, setOpenMobile] = useState(false);
    const navigation = useNavigation();
    const loading = navigation.state === "loading";

    const {
        accounts,
        activeAccount,
        setActiveAccount,
        setIsLoading,
        user,
        logout,
    } = useAuthStore();
    const { getMeters, getReadings } = useMetersStore();

    const activeAcc = accounts?.find((acc) => acc.id === activeAccount);

    const fullAddress = activeAcc
        ? [
            activeAcc.address.region,
            activeAcc.address.city,
            activeAcc.address.street,
            activeAcc.address.plot ? `уч. ${activeAcc.address.plot}` : activeAcc.address.building,
            activeAcc.address.apartment,
        ]
            .filter(Boolean)
            .join(", ")
        : "Адрес не найден";

    const toggle = () =>
        isDesktop ? setOpenDesktop((v) => !v) : setOpenMobile((v) => !v);

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClickAccountsMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseAccountsMenu = () => setAnchorEl(null);

    const handleClickAccount = async (id: number) => {
        try {
            setIsLoading(true);
            setActiveAccount(id);
            handleCloseAccountsMenu();
            await getMeters();
            await getReadings();
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };

    const [mobileMenuOpened, setMobileMenuOpened] = useState(false);

    const handleOpenMobileMenu = () => {
        setMobileMenuOpened(true);
    };

    const handleCloseMobileMenu = () => {
        setMobileMenuOpened(false);
    };

    const DrawerContent = (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <List sx={{ py: 1, display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
                {items.map(({ to, label, Icon }) => (
                    <ListItemButton
                        key={to}
                        component={NavLink}
                        to={to}
                        sx={(t) => ({
                            mx: 1,
                            height: "40px",
                            borderRadius: 1,
                            "&.active": {
                                backgroundColor: t.palette.action.selected,
                            },
                        })}
                        onClick={() => !isDesktop && setOpenMobile(false)}
                    >
                        <Tooltip
                            title={isDesktop && !openDesktop ? label : ""}
                            placement="right"
                        >
                            <ListItemIcon sx={{ minWidth: 40 }}>
                                <Icon htmlColor="#0E74B4" />
                            </ListItemIcon>
                        </Tooltip>
                        {(isDesktop ? openDesktop : true) && (
                            <ListItemText
                                primary={label}
                                sx={{
                                    textWrap: "nowrap",
                                    // height:"40px",
                                    marginLeft: isDesktop ? 0 : "8px",
                                }}
                            />
                        )}
                    </ListItemButton>
                ))}
            </List>

            <Box sx={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                <Box sx={{ display: "inline-block", marginTop: "auto", flex: 1 }}>

                </Box>
                <ListItemButton
                    component={"a"}
                    href={process.env.REACT_APP_HELP_CENTER}
                    sx={(t) => ({
                        mx: 1,
                        height: "40px",
                        borderRadius: 1,
                        "&.active": {
                            backgroundColor: t.palette.action.selected,
                        },
                        mt: "auto",
                        alignSelf: "flex-end",
                        flex: "0 0 auto",
                        marginBottom: "20px"
                    })}
                    onClick={() => !isDesktop && setOpenMobile(false)}
                >
                    <Tooltip
                        title={
                            isDesktop && !openDesktop
                                ? "Вопросы-ответы"
                                : ""
                        }
                        placement="right"
                    >
                        <ListItemIcon sx={{ minWidth: 40 }}>
                            <HelpIcon htmlColor="#0E74B4" />
                        </ListItemIcon>
                    </Tooltip>
                    {(isDesktop ? openDesktop : true) && (
                        <ListItemText
                            primary={"Вопросы-ответы"}
                            sx={{
                                textWrap: "nowrap",
                                // height:"40px",
                                marginLeft: isDesktop ? 0 : "8px",
                            }}
                        />
                    )}
                </ListItemButton>
                {(isDesktop ? openDesktop : true) && (
                    <Box sx={{ px: 2, pb: 2, display: "flex", flexDirection: "column" }}>
                        <Typography variant="caption" color="text.secondary">
                            <a href="/agreement.pdf" target="_blank" style={{ color: "inherit" }}>Пользовательское соглашение</a>
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            <a href="/privacy.pdf" target="_blank" style={{ color: "inherit" }}>Политика конфиденциальности</a>
                        </Typography>
                    </Box>
                )}
            </Box>
        </Box>
    );

    return (
        <Box sx={{ display: "flex" }}>
            <PepAgreementModal />
            <Modal
                open={mobileMenuOpened}
                onClose={handleCloseMobileMenu}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Paper
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "calc(100% - 48px)",
                        padding: "24px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "10px",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            paddingBottom: "8px",
                            borderBottom: "1px solid #ccc",
                            width: "100%",
                        }}
                    >
                        <img
                            src={avatar}
                            alt=""
                            style={{
                                height: "40px",
                            }}
                        />
                        <Typography fontWeight="medium">
                            {user?.email}
                        </Typography>
                    </Box>
                    <Box>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                            }}
                        >
                            <img src={home} alt="" />
                            <div>
                                <div className={style.adress}>
                                    {fullAddress}
                                </div>
                                <div className={style.lic__num}>
                                    ЛС: {activeAcc?.external_id || "Не найдено"}
                                </div>
                            </div>
                            <a onClick={handleClickAccountsMenu}>
                                <img src={more} alt="" />
                            </a>
                        </div>
                    </Box>
                    <Button
                        variant="text"
                        component={Link}
                        to={"/admin/profile"}
                        onClick={handleCloseMobileMenu}
                    >
                        Профиль
                    </Button>
                    <Button variant="text" onClick={() => logout()}>
                        Выйти
                    </Button>
                </Paper>
            </Modal>
            <CssBaseline />

            {/* ——— Фиксированная шапка, всегда на всю ширину ——— */}
            <AppBar
                position="fixed"
                sx={{ zIndex: (t) => t.zIndex.drawer + 1, background: "#FFF" }}
            >
                <Toolbar sx={{ minHeight: APPBAR }}>
                    <IconButton
                        color="inherit"
                        edge="start"
                        onClick={toggle}
                        sx={{ mr: 2 }}
                    >
                        <MenuIcon htmlColor="#0E74B4" />
                    </IconButton>
                    <img
                        src={logo}
                        style={{
                            // flexGrow:"1",
                            maxHeight: "100%",
                        }}
                    />
                    <div className={style.user__menu}>
                        {/* <div className={style.icon__uses}>
                            <a href="#">
                                <img src={message} />
                            </a>
                            <a href="#">
                                <img src={emoji} />
                            </a>
                            <a href="#">
                                <img src={share} />
                            </a>
                        </div> */}
                        <div className={style.user__info}>
                            <img src={home} alt="" />
                            <div>
                                <div className={style.adress}>
                                    {fullAddress}
                                </div>
                                <div className={style.lic__num}>
                                    ЛС: {activeAcc?.external_id || "Не найдено"}
                                </div>
                            </div>
                            <a onClick={handleClickAccountsMenu}>
                                <img src={more} alt="" />
                            </a>
                        </div>
                        {isDesktop ? (
                            <Link to="/admin/profile" className={style.avatar}>
                                <img src={avatar} alt="" />
                            </Link>
                        ) : (
                            <button
                                style={{
                                    background: "none",
                                    outline: "none",
                                    border: "none",
                                }}
                                className={style.avatar}
                                onClick={handleOpenMobileMenu}
                            >
                                <img src={avatar} alt="" />
                            </button>
                        )}
                        <Menu
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleCloseAccountsMenu}
                            sx={{
                                borderRadius: "48px",
                            }}
                        >
                            {accounts?.map((n) => {
                                return (
                                    <MenuItem
                                        onClick={() => handleClickAccount(n.id)}
                                        sx={{
                                            display: "flex",
                                            gap: "16px",
                                            alignItems: "center",
                                        }}
                                        key={n.id}
                                    >
                                        <img
                                            src={
                                                activeAccount == n.id
                                                    ? activeHome
                                                    : home
                                            }
                                        />
                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontWeight: "bold",
                                                    textWrap: "wrap",
                                                    maxWidth: "100%",
                                                }}
                                            >
                                                {[
                                                    n.address.region,
                                                    n.address.city,
                                                    n.address.street,
                                                    n.address.plot ? `уч. ${n.address.plot}` : n.address.building,
                                                    n.address.apartment,
                                                ].filter(Boolean).join(", ")}
                                            </Typography>
                                            <Typography>
                                                ЛС:{" "}
                                                {n?.external_id || "Не найдено"}
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                );
                            })}
                        </Menu>
                    </div>
                </Toolbar>
                {loading && <LinearProgress />}
            </AppBar>

            {/* ——— Меню под шапкой ——— */}
            {isDesktop ? (
                <Drawer
                    variant="permanent"
                    open
                    PaperProps={{
                        elevation: 8, // тень для меню
                        sx: {
                            width: openDesktop ? W : MINI,
                            overflowX: "hidden",
                            transition: (t) => t.transitions.create("width"),
                            borderRight: 0,
                            top: APPBAR, // под шапкой
                            height: `calc(100% - ${APPBAR}px)`,
                            position: "fixed",
                        },
                    }}
                >
                    {DrawerContent}
                </Drawer>
            ) : (
                <Drawer
                    variant="temporary"
                    open={openMobile}
                    onClose={() => setOpenMobile(false)}
                    ModalProps={{ keepMounted: true }}
                    PaperProps={{
                        elevation: 12, // более выразительная тень на мобилке
                        sx: {
                            width: W,
                            top: APPBAR, // под шапкой
                            height: `calc(100% - ${APPBAR}px)`,
                        },
                    }}
                >
                    {DrawerContent}
                </Drawer>
            )}

            {/* ——— Контент: отступ сверху под шапку и слева под меню (на десктопе) ——— */}
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    maxWidth: "100%",
                    overflowX: "hidden",
                    minHeight: "calc(100vh - 64px)",
                    background: "#F0F2F5",
                    p: 3,
                    mt: `${APPBAR}px`,
                    ...(isDesktop && {
                        ml: openDesktop ? `${W}px` : `${MINI}px`,
                    }),
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                }}
            >
                <Outlet />
                <Paper className={style.footer}>
                    © 2026 ООО «ИПК-сервис» ИНН 3662174340
                </Paper>
            </Box>
        </Box>
    );
}
